import React, { Component } from 'react'

import strings from 'translations/ro.json'
import 'stylesheets/palette.scss'

class Springboard extends Component {
	render() {
		return (
			<article className='springboard' id='springboard' >
				<div className='base'>
					<img src={require('media/overview.jpg')} alt='Viorex Comp'/>
				</div>
				<div className='logo-container absolute-centered'>
					<h1 className='logo'>{strings.springboard.title}</h1>
				</div>
			</article>
		)
	}
}

export default Springboard



// WEBPACK FOOTER //
// ./src/components/ui/Springboard.js